import React from 'react';

// @ts-expect-error
import {BusyOverlay} from '@pb/kit-component-busy-overlay';
import {Icons, Sizes} from '@pb/kit-component-icon';

import {Message} from '../message';

import type {MessageProps} from '../message';
import type {FC} from 'react';


/**
 * InfoMessage Props
 */
export interface WarningMessageProps extends Omit<MessageProps, 'color'> {
    /**
     * Show property for dialog layer wrapper
     */
    shown: boolean,
    /**
     * Message can be closed by clicking on overlay
     */
    closeable?: boolean,
    /**
     * Overlay classes for success message
     */
    overlayClassName?: string,
    /**
     * Function will be called when close icon pressed
     */
    onClose: () => void,
}

/**
 * The WarningMessage component. Shows warning message.
 * @deprecated It will be removed in 6 months 09-20-2025. Use Push Notification instead. https://storybook.dev.pitchbookdata.com/?path=/docs/components-push-notification--documentation
 */
export const WarningMessage: FC<WarningMessageProps> = ({
    shown,
    onClose,
    closeable,
    overlayClassName,
    children,
    ...props
}) => {
    return (
        <BusyOverlay shown={shown} closable={closeable} mix={overlayClassName} onClose={onClose}>
            <Message
                {...props}
                iconProps={{type: Icons.WARNING, size: Sizes.Size_14}}
                color="warning"
                onClose={onClose}>
                {children}
            </Message>
        </BusyOverlay>
    );
};

WarningMessage.displayName = 'WarningMessage';
